import type { ReactNode } from 'react';

interface ComingSoonPlaceholderProps {
  icon: ReactNode;
  title: string;
  description: string;
  features?: string;
  children?: ReactNode;
}

export const ComingSoonPlaceholder = ({ 
  icon, 
  title, 
  description, 
  features,
  children 
}: ComingSoonPlaceholderProps) => {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 md:p-6 mt-4">
      <div className="text-center py-6 md:py-8">
        <div className="w-12 md:w-16 h-12 md:h-16 mx-auto mb-3 md:mb-4 bg-gray-200 rounded-full flex items-center justify-center flex-shrink-0">
          {icon}
        </div>
        <h3 className="text-base md:text-lg font-medium text-gray-900 mb-2">{title}</h3>
        <p className="text-sm md:text-base text-gray-600 mb-3 md:mb-4">
          {description}
        </p>
        {features && (
          <div className="text-xs md:text-sm text-gray-500 mb-4 md:mb-6">
            {features}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};